























helpers = require '../../../helpers.coffee'
VeeValidate = require 'vee-validate'

view_model = {
  props:
    has_groups:
      default: false

  data: ->
    contact_list: ''
    line_errors: []
    line_has_errors: {}
    has_line_errors: false
    pristine: true
    emails: {}
    custom_fields: []

  computed:
    attributes: ->
      attributes = [
        this.$t('contacts.attributes.first_name').concat('*'), 
        this.$t('contacts.attributes.last_name').concat('*'), 
        this.$t('contacts.attributes.email').concat('*'), 
        this.$t('contacts.attributes.company_id').concat('*')
      ]
      attributes = attributes.concat([
        this.$t('contacts.attributes.contact_group').concat('*')
      ]) if @has_groups
      attributes = attributes.concat([
        this.$t('contacts.attributes.position'), 
        this.$t('contacts.attributes.telephone'), 
        this.$t('contacts.attributes.cellphone'), 
        this.$t('contacts.attributes.address'), 
        this.$t('contacts.attributes.url'), 
        this.$t('contacts.attributes.linkedIn')
      ])
      attributes = attributes.concat([
        this.$t('contacts.attributes.var1'), 
        this.$t('contacts.attributes.var2'), 
        this.$t('contacts.attributes.var3')
      ])
      attributes = attributes.concat(@custom_fields.map (custom_field) -> custom_field.field)
      attributes.join(', ')

  methods:
    cleanUpTextarea: ->
      @contact_list = (line for line in @contactListLines() when line.trim() != '').join "\n"

    validateUnlessPristine: ->
      @validate() unless @pristine

    validate: ->
      @pristine = false

      @line_errors = []
      @line_has_errors = {}
      @has_line_errors = false

      @contacts = @parseContacts()

      @emails = {}

      for line_number, contact of @contacts
        line_number = parseInt(line_number) + 1
        continue if isNaN line_number
        errors = @validateContact contact

        @addLineErrors line_number, errors if errors

      ! @has_line_errors

    validateContact: (contact) ->
      errors = []

      errors.push this.$t('contacts.label.' + if @has_groups then 'requiredFieldsWithGroups' else 'requiredFields') \
        unless contact.first_name and
               contact.last_name and
               contact.email and
               contact.business?.name and
               (!@has_groups || (contact.contact_group && contact.contact_group.name))

      if @emails.hasOwnProperty(contact.email) then errors.push this.$t('general.label.duplicatedField', { field: contact.email })
      else @emails[contact.email] = 0

      errors.push this.$t('general.label.invalidField', { field: this.$t('contacts.attributes.email'), field_value: contact.email }) unless @validator.validate('email', contact.email)

      errors.length > 0 and errors or false

    contactListLines: ->
      @contact_list.split('\n')

    parseContacts: ->
      @csvLineToContact(line) for line in @contactListLines()

    csvLineToContact: (line) ->
      parts = line.split ','
      contact = new Contact
        first_name: @cleanContactAttribute parts[0]
        last_name: @cleanContactAttribute parts[1]
        email: @cleanContactAttribute parts[2]
        business: { name: @cleanContactAttribute parts[3] }
        business_name: @cleanContactAttribute parts[3]
        contact_group: { name: (if @has_groups then @cleanContactAttribute parts[4] else null) }
        position: @cleanContactAttribute parts[4 + @has_groups]
        telephone: @cleanContactAttribute parts[5 + @has_groups]
        cellphone: @cleanContactAttribute parts[6 + @has_groups]
        address: @cleanContactAttribute parts[7 + @has_groups]
        url: @cleanContactAttribute parts[8 + @has_groups]
        linkedin:  @cleanContactAttribute parts[9 + @has_groups]
        variable1:  @cleanContactAttribute parts[10 + @has_groups]
        variable2:  @cleanContactAttribute parts[11 + @has_groups]
        variable3:  @cleanContactAttribute parts[12 + @has_groups]
        contact_custom_fields: @returnCustomFields(parts)
      contact.full_name = "#{contact.first_name} #{contact.last_name}"
      contact

    contactsToCsvLines: (contacts) ->
      lines = ""
      contacts.forEach (contact, index) =>
        if index != 0 then lines += '\n'
        lines += @contactToCsvLine(contact)
      lines

    contactToCsvLine: (contact) ->
      attributes = [
        contact.first_name, contact.last_name, contact.email,
        contact.business.name, contact.contact_group, contact.position,
        contact.telephone, contact.cellphone, contact.address
      ]
      line = attributes.join(", ")
      line

    cleanContactAttribute: (attribute) ->
      (attribute or '').trim()

    treatBusinessName: (api_errors) ->
      api_errors['empresa'] = api_errors['business.name']
      delete api_errors['business.name']
      api_errors

    treatCustomField: (api_errors, key) ->
      propriety = "Propriedade #{api_errors[key][0]['custom_field_name']}: "
      errors = [
        api_errors[key][0]['custom_field_value']
        api_errors[key][0]['error']
      ]
      api_errors[propriety] = errors
      delete api_errors[key]
      api_errors

    addErrorsWithLinesFromApi: (response_body) ->
      for line_number, api_errors of response_body.line_errors
        # treating business.name
        api_errors = @treatBusinessName(api_errors) if api_errors['business.name']
        # treating custom fields
        for key, _ of api_errors
          if key.search(/^contact_custom_fields.*/) > -1
            api_errors = @treatCustomField(api_errors, key)

        @has_line_errors = true

        errors = ("#{field} #{errors.join(', ')}" for field, errors of api_errors)
        @addLineErrors line_number, errors

    addLineErrors: (line_number, errors) ->
      @has_line_errors = true

      @line_errors.push
        line_number: line_number
        errors: errors

      @line_has_errors[line_number] = true

    lineWithEmail: (email) ->
      for line_number, line of @contactListLines()
        return parseInt(line_number) + 1 if line.includes email

    addErrorsWithoutLinesFromApi: (data) ->
      for taken_email in data.errors.taken_emails
        line_number = @lineWithEmail taken_email
        @addLineErrors(line_number, [this.$t('general.label.duplicatedField', { field: taken_email })]) if line_number

    addErrorsFromApi: (response_body) ->
      @pristine = false
      @clearErrors()
      if response_body.line_errors
        @addErrorsWithLinesFromApi response_body
      else
        @addErrorsWithoutLinesFromApi response_body

    clearErrors: ->
      @line_errors = []
      line_has_errors = {}
      has_line_errors: false

    restoreContacts: (contacts) ->
      @contact_list = @contactsToCsvLines(contacts)
      @publish()

    publish: ->
      @cleanUpTextarea()
      if @validate()
        EventsBus.$emit 'contacts-picker-text-csv-publish', { @contact_list, @contacts }

    returnCustomFields: (parts) ->
      return if @custom_fields.length == 0
      final_custom_fields = []

      for custom_field,index in @custom_fields
        final_custom_fields.push
          value: @cleanContactAttribute parts[13 + @has_groups + index]
          custom_field_id: custom_field.id

      final_custom_fields

    loadCustomFields: ->
      Loader.on()
      new CustomFieldsResource().index(@loadCustomFieldsSuccess, @loadCustomFieldsFail)

    loadCustomFieldsSuccess: (data) ->
      @custom_fields = data.custom_fields
      Loader.off()

    loadCustomFieldsFail: ->
      Loader.off()
      alertify.error(this.$t('contacts.label.customFieldsFailLoading'))

  mounted: ->
    LinedTextarea.initialize('textarea.lined')

  created: ->
    @loadCustomFields()
    @validator = new VeeValidate.Validator email: 'email'
    EventsBus.$on 'contacts-picker-text-csv-validate', @publish
    EventsBus.$on 'contacts-picker-text-csv-errors', @addErrorsFromApi
    EventsBus.$on 'contacts-picker-text-csv-restore', @restoreContacts

  beforeDestroy: ->
    EventsBus.$off 'contacts-picker-text-csv-validate', @publish
    EventsBus.$off 'contacts-picker-text-csv-errors', @addErrorsFromApi
    EventsBus.$off 'contacts-picker-text-csv-restore', @restoreContacts

}

exports.default = view_model




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/picker/text_csv.vue